module.exports = __webpack_public_path__ + "img/max-file-configure--excel.2cd43b99.svg";